module.exports = __webpack_public_path__ + "img/full5-min.7b73d63f.png";